module.exports = __webpack_public_path__ + "img/calendar-light.12360b0b.svg";